// extracted by mini-css-extract-plugin
export default {"root":"Status_root__jwwZK","state1":"Status_state1__J44qz","state2":"Status_state2__Bufan","state3":"Status_state3__8788a"};